const redirect =  
process.env.VUE_APP_SIGN_IN + '/app/login?app_key=' + 
process.env.VUE_APP_SIGN_IN_ID + '&app_secret='+ 
process.env.VUE_APP_SIGN_IN_SECRET +'&current_url=' + 
window.location;


export default redirect